// src/pages/AccountsPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";


function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease;
            }
            .grid-rows-pro table tbody tr:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro table tbody tr:hover {
                background: #eff6ff !important;
            }
            .grid-rows-pro table tbody td {
                font-size: 14px;
                color: #111827;
                vertical-align: top;
            }
            .grid-rows-pro table tbody td .grid-row-main {
                font-weight: 700;
                color: #111827;
            }
            .grid-rows-pro table tbody td .grid-row-sub {
                color: #6b7280;
                font-size: 12px;
            }
            .grid-rows-pro .list-hover-item {
                transition: background 0.18s ease;
            }
            .grid-rows-pro .list-hover-item:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro .list-hover-item:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro .list-hover-item:hover {
                background: #eff6ff !important;
            }
        `}</style>
    );
}


function AccountsLeadWebStyle() {
    return (
        <style>{`
            .accounts-pro{color:#f5fbff}
            .accounts-pro select option{background:#061a2f;color:white}
            .accounts-pro .crm-hero{background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);border:1px solid rgba(11,93,140,.8);box-shadow:0 20px 45px rgba(0,0,0,.28)}
            .accounts-pro .crm-card{border:1px solid rgba(11,93,140,.82);background:#04192b;box-shadow:0 12px 30px rgba(0,0,0,.24)}
            .accounts-pro .crm-card-head{background:#031425;border-bottom:1px solid #0b4d78}
            .accounts-pro .crm-actions-bar{background:#031425;border:1px solid #0b4d78;border-radius:22px}
            .accounts-pro .crm-btn{border:1px solid #24537a;background:#0b2740;color:#f5fbff;border-radius:999px;padding:10px 14px;font-size:12px;font-weight:700}
            .accounts-pro .crm-btn:hover{background:#10324f;border-color:#d4af37}
            .accounts-pro .crm-btn-primary{background:#d4af37;color:#081a2b;border-color:#d4af37}
            .accounts-pro .crm-btn-primary:hover{background:#e8c457}
            .accounts-pro .crm-input{width:100%;border:1px solid #0b5f91;border-radius:.85rem;padding:.65rem .75rem;font-size:12px;outline:none;background:#0b2740;color:#fff}
            .accounts-pro .crm-input::placeholder{color:#7ea8c7}
            .accounts-pro .crm-input:focus{border-color:#d4af37;box-shadow:0 0 0 2px rgba(212,175,55,.18)}
            .accounts-pro .crm-label{display:block;font-size:11px;color:#8fb9da;margin-bottom:6px;font-weight:700;text-transform:uppercase;letter-spacing:.14em}
            .accounts-pro table{border-collapse:separate;border-spacing:0;background:#061a2f}
            .accounts-pro table tbody tr{transition:background .18s ease, box-shadow .18s ease;background:#08233d!important}
            .accounts-pro table tbody tr:nth-child(even){background:#092a49!important}
            .accounts-pro table tbody tr:hover{background:rgba(56,189,248,.075)!important;box-shadow:inset 3px 0 0 #d4af37}
            .accounts-pro table tbody td{border-top:1px solid #24587c;background:transparent!important;color:#f5fbff}
            .accounts-pro table thead th{position:sticky;top:0;z-index:10;background:#061a2f!important;color:#8fb9da;border-bottom:1px solid #24587c;text-transform:uppercase;letter-spacing:.13em}
            .accounts-pro .crm-scroll{overflow:auto;max-height:70vh}
            .accounts-pro .crm-scroll-top{overflow-x:auto;overflow-y:hidden;height:14px;border:1px solid #24587c;border-radius:999px;background:#061a2f;margin:0 12px 8px 12px}
            .accounts-pro .crm-scroll-spacer{height:1px;min-width:1100px}
            .accounts-pro .crm-scroll::-webkit-scrollbar,.accounts-pro .crm-scroll-top::-webkit-scrollbar{height:10px;width:10px}
            .accounts-pro .crm-scroll::-webkit-scrollbar-track,.accounts-pro .crm-scroll-top::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .accounts-pro .crm-scroll::-webkit-scrollbar-thumb,.accounts-pro .crm-scroll-top::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .accounts-pro .crm-scroll::-webkit-scrollbar-thumb:hover,.accounts-pro .crm-scroll-top::-webkit-scrollbar-thumb:hover{background:#d4af37}
            .accounts-pro .grid-row-main{font-weight:700;color:#fff!important}
            .accounts-pro .grid-row-sub{color:#9fc4df!important;font-size:12px}
            .accounts-pro .crm-badge{display:inline-flex;align-items:center;border-radius:999px;border:1px solid #24537a;background:#0f2d48;color:#d9e8f5;padding:4px 9px;font-size:10px;font-weight:700}
            .accounts-pro .crm-modal-panel{background:#04192b;border:1px solid #0b5f91;color:#fff;box-shadow:0 20px 60px rgba(0,0,0,.35)}
            .accounts-pro .crm-modal-head{background:#031425;border-bottom:1px solid #0b4d78}
        `}</style>
    );
}

const AccountsPage = () => {
    const navigate = useNavigate();
    const [accounts, setAccounts] = useState([]);
    const [oppsCountByAccount, setOppsCountByAccount] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError("");

                const [accRes, oppRes] = await Promise.all([
                    fetch("${API_BASE}/accounts_list.php"),
                    fetch("${API_BASE}/opportunities_list.php"),
                ]);

                const accData = await accRes.json().catch(() => []);
                const oppData = await oppRes.json().catch(() => []);

                const accList = Array.isArray(accData) ? accData : [];
                const oppList = Array.isArray(oppData) ? oppData : [];

                setAccounts(accList);

                // Mapa: account_id -> número de oportunidades
                const counts = {};
                for (const o of oppList) {
                    const accId = Number(o.account_id);
                    if (!accId) continue;
                    counts[accId] = (counts[accId] || 0) + 1;
                }
                setOppsCountByAccount(counts);
            } catch (err) {
                console.error(err);
                setError("No se pudieron cargar las cuentas.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const formatDate = (dtString) => {
        if (!dtString) return "-";
        const [y, m, d] = dtString.split(" ")[0].split("-");
        if (!y || !m || !d) return dtString;
        return `${d}/${m}/${y}`;
    };

    return (
        <MainLayout>
            <GridRowsProStyle />
            <AccountsLeadWebStyle />
            <div className="accounts-pro min-h-screen bg-[#041426] px-3 py-6 md:px-6 md:py-8 grid-rows-pro"><div className="mx-auto max-w-[1500px] space-y-6">
                {/* Header */}
                <div className="crm-hero rounded-[28px] px-6 py-6 md:px-7 md:py-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                        <p className="mb-3 inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]"><span className="h-px w-10 bg-[#D4AF37]" />CRM Comercial</p><h2 className="text-3xl md:text-4xl font-black tracking-tight text-white">Cuentas</h2>
                        <p className="text-sm md:text-base text-[#d7e8f6] max-w-3xl leading-relaxed">Empresas con las que construyes relación comercial, oportunidades y proyectos.</p>
                    </div>
                    <div className="flex gap-2 text-xs">
                        {/* Botón para crear cuenta */}
                        <button
                            type="button"
                            onClick={() => navigate("/accounts/new")} // ajusta aquí si tu ruta es otra
                            className="crm-btn crm-btn-primary"
                        >
                            + Nueva cuenta
                        </button>
                    </div>
                </div>

                {error && (
                    <div className="mb-2 text-xs text-[#fca5a5] bg-[#2b1117] border border-[#ef4444]/40 rounded-lg px-3 py-2">
                        {error}
                    </div>
                )}

                {/* Tabla de cuentas */}
                <div className="crm-card rounded-[24px] overflow-hidden">
                    <div className="crm-card-head px-5 py-4 flex items-center justify-between">
                        <h3 className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#d4af37]">
                            Listado de cuentas
                        </h3>
                        <span className="text-[11px] text-[#9fc4df]">
                            Total: {accounts.length}
                        </span>
                    </div>

                    <div className="crm-scroll">
                        <table className="min-w-full text-xs">
                            <thead className="bg-[#08233d]">
                                <tr className="text-left text-[11px] font-semibold text-[#d7e8f6]">
                                    <th className="px-3 py-2">Cuenta</th>
                                    <th className="px-3 py-2 hidden sm:table-cell">
                                        Alias / Sector
                                    </th>
                                    <th className="px-3 py-2 hidden md:table-cell">
                                        Ubicación
                                    </th>
                                    {/* Columna: número de oportunidades */}
                                    <th className="px-3 py-2 hidden sm:table-cell">
                                        Oportunidades
                                    </th>
                                    <th className="px-3 py-2 text-right">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr>
                                        <td
                                            colSpan={5}
                                            className="px-3 py-4 text-center text-[#9fc4df]"
                                        >
                                            Cargando cuentas...
                                        </td>
                                    </tr>
                                )}

                                {!loading && accounts.length === 0 && (
                                    <tr>
                                        <td
                                            colSpan={5}
                                            className="px-3 py-4 text-center text-[#8fb9da]"
                                        >
                                            Aún no se han registrado cuentas.
                                        </td>
                                    </tr>
                                )}

                                {!loading &&
                                    accounts.map((account) => {
                                        const accId = Number(account.id);
                                        const oppCount = oppsCountByAccount[accId] || 0;

                                        return (
                                            <tr
                                                key={account.id}
                                                className="border-t border-[#0b4d78] hover:bg-[#10324f]/60"
                                            >
                                                {/* Nombre de la cuenta: clic → detalle */}
                                                <td className="px-3 py-2 text-[11px] text-white">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            navigate(`/accounts/${account.id}`)
                                                        }
                                                        className="text-[#8fd8ff] hover:underline"
                                                    >
                                                        {account.name}
                                                    </button>
                                                </td>

                                                <td className="px-3 py-2 hidden sm:table-cell text-[11px] text-[#d7e8f6]">
                                                    {account.alias || account.sector || "-"}
                                                </td>

                                                <td className="px-3 py-2 hidden md:table-cell text-[11px] text-[#d7e8f6]">
                                                    {[account.city, account.state, account.country]
                                                        .filter(Boolean)
                                                        .join(", ") || "-"}
                                                </td>

                                                {/* Conteo de oportunidades */}
                                                <td className="px-3 py-2 hidden sm:table-cell text-[11px] text-[#d9e8f5]">
                                                    {oppCount}
                                                </td>

                                                {/* Acciones */}
                                                <td className="px-3 py-2 text-right text-[11px] text-[#d7e8f6]">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            navigate(`/accounts/${account.id}`)
                                                        }
                                                        className="px-2 py-1 rounded-lg border border-[#0b4d78] hover:bg-[#10324f]"
                                                    >
                                                        Ver detalle
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            </div>
        </MainLayout>
    );
};

export default AccountsPage;
